import { Component } from '@angular/core';
import { PageService } from '../../core/page.service';
import { AnalyticsPage } from '../../core/internal-analytics.service';

@Component({
    selector: 'rosie-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {

  constructor(private page: PageService) {
    this.page.initializePage(`Rosie - Not Found`, AnalyticsPage.NotFound);
  }
}
